import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as game from '../../controllers';
import logo from '../../images/logoFlat.svg';
import { ACTIONS } from '../../actions/actionTypes';
import SelectInput from '../components/selectInput';
import Spinner from '../components/spinner';
import errorCatcher from '../../utils/errorCatcher';

const gender = [
    {_id: 'Masculino', name: 'Masculino'},
    {_id: 'Feminino', name: 'Feminino'}
];

class UserData extends Component {
    constructor (props) {
        super(props);
        this.state = {
            cities: [{_id: 'Outra Cidade', name: 'Outra Cidade'}],
            showOtherCity: false,
            dateType: 'text',
            schoolType: 'text',
            genderType: 'text',
            cityType: 'text',
            error: null
        };
        this.onSubmitUserData = this.onSubmitUserData.bind(this);
    }

    onCitySelectChange (value) {
        this.props.inputChanged('city', value);
        this.setState({showOtherCity: value === 'Outra Cidade'});
    }

    onSchoolSelectChange (value) {
        this.props.inputChanged('school', value);
    }

    onDateSelectChange (value) {
        this.props.inputChanged('birthdate', value);
    }

    onGenderSelectChange (value) {
        this.props.inputChanged('gender', value);
    }

    getCities () {
        game.cities.getCities().then(response => {
            response.map(item => {
                item.name = item.title;
                delete item.title;
                return item;
            });
            response.push({_id: 'Outra Cidade', name: 'Outra Cidade'});
            this.setState({cities: response});
        }).catch((err) => errorCatcher(err));
    }

    componentDidMount () {
        this.props.getSchools();
        this.getCities();
    }

    onSubmitUserData () {
        const {name, city, birthdate, gender, school, pushNotificationToken, otherCity} = this.props.input;
        let error = null;
        if (!birthdate) {
            error = 'Data de nascimento obrigatória';
        }
        if (!name) {
            error = 'Nome obrigatório';
        }
        let updatedData = {
            ...this.props.user.data, birthdate, city, gender, school: school === 'Nenhuma dessas' ? null : school, otherCity
        };
        let updatedUser = {
            ...this.props.user, name: this.props.input.name, data: updatedData, pushNotificationToken
        };
        this.setState({error});
        if (!error) {
            this.props.updateUser(updatedUser);
            this.forceUpdate();
        }
    }

    getSchoolbyCity () {
        let citySchools = [];
        citySchools = this.props.schools.filter((school) => {
            if (school.city === this.props.input.city) { return school; }
        });
        citySchools = citySchools.filter(school => !!school.city);
        citySchools.push({_id: null, name: 'Nenhuma dessas'});
        return citySchools;
    }

    renderSelectSchoolByCity () {
        let schools = this.getSchoolbyCity();
        if (schools.length > 1) {
            return (
                <div className='input-field-wrapper'>
                    <SelectInput options={schools} defaultValue={schools[0]._id}
                        onChange={(value) => this.onSchoolSelectChange(value)} />
                </div>
            );
        } else {
            this.onSchoolSelectChange(null);
        }
        return null;
    }

    changeType (key, type) {
        this.setState((state) => {
            state[key + 'Type'] = type;
            return state;
        });
    }

    convertToText (date) {
        if (date) {
            return date.split('-').reverse().join('/');
        }
    }

    render () {
        if (!this.props.schools || this.props.loading) {
            return (
                <div className='auth-background userData flex'>
                    <Spinner />
                </div>
            );
        }

        return (
            <div className='auth-background userData'>
                <div className='auth-logo-wrapper'>
                    <img className='auth-logo' src={logo} alt='logo' />
                </div>
                <div className='userdata-info'>
                    Preencha mais algumas de suas informações para continuar.
                </div>
                <div className='input-field-wrapper'>
                    <input type='text' value={this.props.input.name} placeholder='Nome' className='input-field'
                        onChange={(e) => this.props.inputChanged('name', e.target.value)} />
                </div>
                {
                    this.state.cities.length > 1
                        ? <div className='input-field-wrapper'>
                            <SelectInput options={this.state.cities} searchKey='name' defaultValue='Juiz de Fora'
                                onChange={(value) => this.onCitySelectChange(value)} />
                        </div>
                        : null
                }
                {
                    (this.state.showOtherCity)
                        ? <div className='input-field-wrapper'>
                            <input type='text' value={this.props.input.otherCity} placeholder='Nome da cidade'
                                className='input-field'
                                onChange={(e) => this.props.inputChanged('otherCity', e.target.value)} />
                        </div>
                        : null
                }

                {this.renderSelectSchoolByCity()}

                <div className='input-field-wrapper'>
                    <SelectInput
                        options={gender}
                        defaultValue={gender[0]._id}
                        onChange={(value) => this.onGenderSelectChange(value)} />
                </div>
                <div className='input-field-wrapper'>
                    <input
                        type={this.state.dateType}
                        value={this.state.dateType === 'text'
                            ? this.convertToText(this.props.input.birthdate)
                            : this.props.input.birthdate
                        }
                        placeholder='Data de Nascimento'
                        className='input-field'
                        onFocus={() => this.changeType('date', 'date')}
                        onBlur={() => this.changeType('date', 'text')}
                        onChange={(e) => this.onDateSelectChange(e.target.value)} />
                </div>
                <ErrorRenderer
                    condition={this.state.error}
                    message={this.state.error} />
                <div className='container-buttons'>
                    <div className='btn block login' onClick={this.onSubmitUserData}>
                        <h4>Entrar</h4>
                    </div>
                </div>
                <br />
            </div>
        );
    }
}

const ErrorRenderer = (props) => (
    <div className='auth-error-container'>
        <div className='auth-error-wrapper'>
            {
                props.condition
                ? <span className='auth-error-message'>{props.message}</span>
                : null
        }
        </div>
    </div>
);

const mapStateToProps = (state) => ({
    user: state.user.user,
    auth: state.user,
    input: state.user.input,
    schools: state.school.schools,
    loading: state.user.loadingData
});

const mapDispatchToProps = (dispatch) => ({
    inputChanged: (key, value) => dispatch({type: ACTIONS.USER_INPUT_CHANGED, payload: {key, value}}),
    updateUser: (input) => dispatch({type: ACTIONS.USER_UPDATE_REMOTE_DATA, payload: input}),
    givePointsToWhoInvited: () => dispatch({type: ACTIONS.USER_UPDATE_REMOTE_DATA, payload: 10}),
    getSchools: () => dispatch({type: ACTIONS.GET_SCHOOLS})
});

export default connect(mapStateToProps, mapDispatchToProps)(UserData);



// WEBPACK FOOTER //
// ./src/views/AuthViews/userDataView.js